/**
 * @param {number} totalMonths
 * @returns {{ years: number, months: number }}
 */
export const fromTotalMonths = (
  totalMonths: number,
): { months: number; years: number } => {
  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;

  return { months, years };
};
